import {useReducer} from "react";
import {
  offeringFormCheckoutFormQuestionAccordionReducer,
  initialOfferingFormCheckoutFormQuestionAccordionState,
} from "../reducers";

export function useOfferingFormCheckoutFormAccordion({
  reducer = offeringFormCheckoutFormQuestionAccordionReducer,
}: {
  reducer: typeof offeringFormCheckoutFormQuestionAccordionReducer;
}) {
  const [state, dispatch] = useReducer(
    reducer,
    initialOfferingFormCheckoutFormQuestionAccordionState
  );
  const toggleIndex = (index: number) => dispatch({type: "toggle_index", payload: index});
  return {openIndexes: state.openIndexes, toggleIndex};
}
